module.exports = __webpack_public_path__ + "img/linkedin.5c337329.jpg";